<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  formData: {
    is_active: boolean;
    is_stackable: boolean;
    priority: number;
    max_uses_per_order?: number;
    max_uses_total?: number;
    min_order_total?: number;
  };
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:formData': [value: any];
}>();

const formData = computed({
  get: () => props.formData,
  set: (value) => emit('update:formData', value)
});
</script>

<template>
  <div class="border-t border-gray-200 dark:border-gray-700 pt-6">
    <h4 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
      Configuración Adicional
    </h4>
    
    <div class="space-y-3">
      <div>
        <label class="flex items-center">
          <input
            :checked="formData.is_active"
            type="checkbox"
            class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            @change="formData.is_active = ($event.target as HTMLInputElement).checked"
          >
          <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Promoción activa
          </span>
        </label>
      </div>

      <div>
        <label class="flex items-center">
          <input
            :checked="formData.is_stackable"
            type="checkbox"
            class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            @change="formData.is_stackable = ($event.target as HTMLInputElement).checked"
          >
          <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Se puede combinar con otras promociones
          </span>
        </label>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Prioridad
          </label>
          <input
            :value="formData.priority"
            type="number"
            min="1"
            required
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
            @input="formData.priority = Number(($event.target as HTMLInputElement).value)"
          >
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Límite total de usos (opcional)
          </label>
          <input
            :value="formData.max_uses_total"
            type="number"
            min="1"
            placeholder="Sin límite"
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
            @input="formData.max_uses_total = ($event.target as HTMLInputElement).value ? Number(($event.target as HTMLInputElement).value) : undefined"
          >
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Límite de usos por orden (opcional)
        </label>
        <input
          :value="formData.max_uses_per_order"
          type="number"
          min="1"
          placeholder="Sin límite"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          @input="formData.max_uses_per_order = ($event.target as HTMLInputElement).value ? Number(($event.target as HTMLInputElement).value) : undefined"
        >
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Total mínimo de orden (opcional)
        </label>
        <input
          :value="formData.min_order_total"
          type="number"
          step="0.01"
          min="0"
          placeholder="Sin mínimo"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          @input="formData.min_order_total = ($event.target as HTMLInputElement).value ? Number(($event.target as HTMLInputElement).value) : undefined"
        >
      </div>
    </div>
  </div>
</template>
